import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { AutoScroll } from '~/components/ui/AutoScroll'
import { getTabs_aiArtworkResourceModule_aiSquareTab_tab_child } from '~/graphqls/types'
import useSearchParams from '~/hooks/useSearchParam'
import { to400Image } from '~/utils'

import styles from './TabArtistTiled.module.css'

interface Props {
  items: Array<getTabs_aiArtworkResourceModule_aiSquareTab_tab_child>
}

export default function TabArtistTiled({ items }: Props) {
  const router = useRouter()
  const { artistid } = useSearchParams()

  /** 选择艺术家，单选 */
  const setArtistId = (id: string) => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          artistid: id === artistid ? '' : id,
        },
      },
      undefined,
      { shallow: true }
    )
  }

  const [artistOpts, id2index] = useMemo(() => {
    let ret = []
    let id2index: Record<string, number> = {}
    let opts = items
    for (let i = 0; i < opts.length; ) {
      const a = opts[i++]
      const b = opts[i++]
      if (b) {
        ret.push([a, b])
        id2index[a.idStr!] = Math.floor((i - 1) / 2)
        id2index[b.idStr!] = Math.floor((i - 1) / 2)
      } else {
        ret.push([a])
        id2index[a.idStr!] = Math.floor((i - 1) / 2)
      }
    }
    return [ret, id2index]
  }, [items])

  return (
    <div>
      <AutoScroll activeIndex={id2index[artistid as string]} hasArrow>
        <div className="flex items-start">
          {artistOpts.map((item, index) => {
            return (
              <div
                key={index}
                className={classNames({
                  'ml-3': index > 0,
                })}
              >
                <div
                  className={classNames(styles.simpleCard, {
                    [styles.simpleCardActive]: artistid === item[0].idStr,
                  })}
                  style={{
                    backgroundImage: `linear-gradient(
                    to bottom,
                    rgba(0, 0, 0, 0.1),
                    rgba(0, 0, 0, 0.5)
                  ), url(${to400Image(item[0].icon!)})`,
                  }}
                  onClick={() => {
                    setArtistId(item[0].idStr!)
                  }}
                >
                  <div className={styles.simpleCardHover}>
                    <div className="mb-1">{item[0].englishName}</div>
                    <div>{item[0].name}</div>
                  </div>
                </div>
                {!!item[1] && (
                  <div
                    className={classNames(styles.simpleCard, 'mt-2', {
                      [styles.simpleCardActive]: artistid === item[1].idStr,
                    })}
                    style={{
                      backgroundImage: `linear-gradient(
                      to bottom,
                      rgba(0, 0, 0, 0.1),
                      rgba(0, 0, 0, 0.5)
                    ), url(${to400Image(item[1].icon!)})`,
                    }}
                    onClick={() => {
                      setArtistId(item[1].idStr!)
                    }}
                  >
                    <div className={styles.simpleCardHover}>
                      <div className="mb-1">{item[1].englishName}</div>
                      <div>{item[1].name}</div>
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </AutoScroll>
    </div>
  )
}
